<template>
  <div class="whats-it-content-component">
    <tempalte v-if="isDesktop">
      <!-- Desktop Fullscreen -->
      <vs-popup
        fullscreen
        :title="titlePopup"
        @close="closePdfMaximized"
        :active.sync="activePdfViewerMaximized"
        class="whats-it-popup"
      >
        <div @contextmenu.prevent style="height: 100%">
          <iframe :src="getUrl()" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </vs-popup>

      <!-- <PDFToolbar
        :scale="scaleMinimized"
        :isMaximized="activePdfViewerMaximized"
        :displayDownloadBtn="false"
        :displayPrintBtn="false"
        :displayZoomOutBtn="true"
        :displayZoomInBtn="true"
        @change="changeScaleMinimized"
        @maximize="maximizePdf"
        class="header-item"
      /> -->

      <iframe v-if="isPdfViewerVisible" :src="getUrl()" frameborder="0" width="100%" height="100%"></iframe>
    </tempalte>
    <template v-else>
      <!-- Desktop Fullscreen -->
      <vs-popup
        fullscreen
        :title="titlePopup"
        @close="closePdfMaximized"
        :active.sync="activePdfViewerMaximized"
        class="whats-it-popup"
      >
        <pdf-viewer v-if="activePdfViewerMaximized" :isMaximized="false" :url="getUrl()"
        title="" :scale="scaleMinimized" @closePdfViewerEvent="closePdfViewer"
        @updateScaleViewerEvent="updateScaleInfoView"></pdf-viewer>
      </vs-popup>
      <PDFToolbar
        :scale="scaleMinimized"
        :isMaximized="false"
        :displayDownloadBtn="false"
        :displayPrintBtn="false"
        :displayZoomOutBtn="true"
        :displayZoomInBtn="true"
        @change="changeScaleMinimized"
        @maximize="maximizePdf"
        class="header-item"
      />
      <pdf-viewer v-if="isPdfViewerVisible" :isMaximized="false" :url="getUrl()"
        title="" :scale="scaleMinimized" @closePdfViewerEvent="closePdfViewer"
        @updateScaleViewerEvent="updateScaleInfoView"></pdf-viewer>
    </template>
  </div>
</template>

<script>
import AppConstants from "../../../appConstants";
import localStorageHelper from '../../../helpers/local-storage-helper';
import { getWhatsitDocumentURLByLocale } from '../../../helpers/locale-helper';
import PDFToolbar from "../widgets/pdf/PDFToolbar";
import PdfViewer from '../widgets/PdfViewer.vue';
// import PdfViewer from "../widgets/PdfViewer";

export default {
  data() {
    return {
      scaleMinimized: 1.8,
      scaleMaximized: 2.5,
      activePdfViewerMaximized: false,
      isPdfViewerVisible: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5,
      },
    };
  },
  props: {
    isDesktop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return "";
    },
    titlePopup() {
      return "";
    },
  },
  created() {},
  methods: {
    getUrl() {
      console.log('geturl')
      return getWhatsitDocumentURLByLocale(this.$i18n.locale);
    },
    changeScaleMaximized(data) {
      this.scaleMaximized = data;
    },
    changeScaleMinimized(data) {
      this.scaleMinimized = data;
    },
    updateScaleInfoView(scale) {
      this.scaleMinimized = scale;
    },
    maximizePdf(value) {
      if (value) {
        this.closePdfViewer();
        this.activePdfViewerMaximized = true;
      } else {
        this.closePdfMaximized();
      }
    },
    closePdfMaximized() {
      this.activePdfViewerMaximized = false;
      this.isPdfViewerVisible = true;
    },
    closePdfViewer() {
      this.isPdfViewerVisible = false;
    },
  },
  components: {
    PDFToolbar,
    PdfViewer,
    // PdfViewer,
  },
};
</script>

<style lang="scss">
  
</style>